import { render, staticRenderFns } from "./ErroInicializacao.vue?vue&type=template&id=3ceed63e"
import script from "./ErroInicializacao.vue?vue&type=script&lang=js"
export * from "./ErroInicializacao.vue?vue&type=script&lang=js"
import style0 from "./ErroInicializacao.vue?vue&type=style&index=0&id=3ceed63e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports